import { Page } from '@/components';
import TokensBaseTable from './Table';
export default function TokensUnichainPage() {
  return (
    <Page title="Tokens">
      <TokensBaseTable />
    </Page>
  );
}
